import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import SiteSearch from 'components/SiteSearch/SiteSearch';
import { SEARCH_VARIANT } from 'constants/Shared';

function SearchBarHandler(props) {
    const {
        sid, datasource, placeholder, refinements, deliveryOption, sotSubType, shouldRender = true
    } = props;

    if (!shouldRender) {
        return null;
    }

    return (
        <Box
            key={sid || datasource?.sid}
            marginTop={[6, 7]}
            marginBottom={[-4, -5]}
        >
            {datasource?.title && (
                <Text
                    is='h2'
                    marginBottom={4}
                    fontSize={['lg', 'xl']}
                    lineHeight='none'
                    fontWeight='bold'
                >
                    {datasource.title}
                </Text>
            )}
            <Box maxWidth={[null, '50%', '33%']}>
                <SiteSearch
                    id='sys_search'
                    placeholder={placeholder}
                    variant={SEARCH_VARIANT.SYS}
                    refinements={refinements}
                    deliveryOption={deliveryOption}
                    sotSubType={sotSubType}
                />
            </Box>
        </Box>
    );
}

export default wrapFunctionalComponent(SearchBarHandler, 'SearchBarHandler');
